
export enum FleetSurveyRating {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Bad = 'BAD',
}
